"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UnauthorizedException;
require("core-js/modules/es.function.name.js");
function UnauthorizedException(data) {
  this.name = 'UnauthorizedException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
UnauthorizedException.constructor = UnauthorizedException;